import { createContext, useEffect, useState } from "react";
import { RolePermission } from "../constants/api-urlConstants";
import instance from "../utils/axiosInstance";

export const RolePersmission = createContext<any>([]);

export const PermissionForRoles = (props: any) => {

  const { children } = props;
  const [permissionsObj, setPermissionsObj] = useState<any>({});
  const [loadingStatus, SetloadingStatus] = useState<any>(false);

  const getRolePermission = () => {
    SetloadingStatus(true)
    const USER_API_BASE_URL = `${RolePermission}`;
    instance
      .get(USER_API_BASE_URL, { withCredentials: true })
      .then((response) => {
        const res = response.data.data;
        SetloadingStatus(false)
        setPermissionsObj(res)

      })
      .catch((error) => {
      });
  }

  useEffect(() => {
    getRolePermission();
  }, []);

  return (
    <RolePersmission.Provider value={{ permissionsObj, loadingStatus }}>
      {
        children
      }
    </RolePersmission.Provider>
  )
}

